import {
  ROUTE_ADDRESS_HOME,
  ROUTE_BICYCLE_CITY,
  ROUTE_BICYCLE_DEPARTMENT,
  ROUTE_BICYCLE_HOME,
  ROUTE_BICYCLE_REGION,
  ROUTE_DEPARTMENT_HOME,
  ROUTE_HOME,
  ROUTE_ITINERARY_COMPUTING,
  ROUTE_ITINERARY_COMPUTING_BY_MODE,
  ROUTE_ITINERARY_EXPENSE_REPORT,
  ROUTE_ITINERARY_HOME,
  ROUTE_ITINERARY_HP_BY_MODE,
  ROUTE_ITINERARY_RESULTS_BY_PROVIDER,
  ROUTE_ITINERARY_RESULTS_BY_ROUTE,
  ROUTE_ITINERARY_ROADBOOK,
  ROUTE_ITINERARY_TO,
  ROUTE_ITINERARY_TO_BY_MODE,
  ROUTE_REGION_HOME,
  ROUTE_RESTRICTION_CITY,
  ROUTE_RESTRICTION_DEPARTMENT,
  ROUTE_RESTRICTION_HOME,
  ROUTE_RESTRICTION_REGION,
  ROUTE_SEO_ADDRESS,
  ROUTE_SEO_CITY_ACTIVITY,
  ROUTE_SEO_CITY_APP,
  ROUTE_SEO_COUNTRY,
  ROUTE_SEO_DEPARTMENT,
  ROUTE_SEO_DIRECTORY_CITY,
  ROUTE_SEO_DIRECTORY_CITY_ACTIVITY,
  ROUTE_SEO_DIRECTORY_CITY_OVM_POIS,
  ROUTE_SEO_DIRECTORY_CITY_OVM_POIS_ACTIVITY,
  ROUTE_SEO_DIRECTORY_CITY_POIS,
  ROUTE_SEO_DIRECTORY_ITINERARY,
  ROUTE_SEO_DIRECTORY_ITINERARY_BY_MODE,
  ROUTE_SEO_DIRECTORY_LANDMARK,
  ROUTE_SEO_DIRECTORY_NAMED_PLACE,
  ROUTE_SEO_DIRECTORY_SKI_RESORT,
  ROUTE_SEO_GEOENTITY,
  ROUTE_SEO_ITINERARY,
  ROUTE_SEO_ITINERARY_MODE,
  ROUTE_SEO_LANDMARK,
  ROUTE_SEO_NAMED_PLACE,
  ROUTE_SEO_SEARCH_BY_APP,
  ROUTE_SEO_SEARCH_BY_RUBRIC,
  ROUTE_TOOLS_COMPUTE_RADIUS,
  ROUTE_TRAFFIC_CITY,
  ROUTE_TRAFFIC_DEPARTMENT,
  ROUTE_TRAFFIC_HOME,
  ROUTE_TRAFFIC_REGION,
  ROUTE_ZFE_CITY,
  ROUTE_ZFE_DEPARTMENT,
  ROUTE_ZFE_HOME,
  ROUTE_ZFE_REGION
} from '../../../routes'
import { selectFirstAddress } from '../../../store/address/address.selectors'
import { selectCurrentGeoentity } from '../../../store/geoentity/geoentity.selectors'
import { selectCurrentHistoryRoute } from '../../../store/history/history.selectors'
import { projectDistrictZipcodeToWholeCityZipcode } from '../../utils/location'
import { createCustomSelector } from '../../utils/react-reselect'

export const selectShouldDisplayTopSearchTitle = createCustomSelector(
  selectCurrentHistoryRoute,
  route => route !== ROUTE_SEO_ITINERARY && route !== ROUTE_SEO_ITINERARY_MODE
)

export const selectSeoItineraryLinkLabelPrefix = createCustomSelector(selectCurrentHistoryRoute, route => {
  switch (route) {
    case ROUTE_HOME:
    case ROUTE_SEO_GEOENTITY:
      return ''
    case ROUTE_SEO_CITY_ACTIVITY:
      return 'Trajet'
    case ROUTE_ADDRESS_HOME:
    case ROUTE_SEO_ADDRESS:
    case ROUTE_TRAFFIC_CITY:
    case ROUTE_BICYCLE_CITY:
    case ROUTE_SEO_DIRECTORY_CITY_ACTIVITY:
    case ROUTE_SEO_DIRECTORY_CITY_OVM_POIS:
    case ROUTE_ZFE_CITY:
    case ROUTE_RESTRICTION_CITY:
      return 'Distance'
    case ROUTE_ITINERARY_HP_BY_MODE:
    case ROUTE_SEO_ITINERARY_MODE:
      return 'Itinéraire {mode}'
    case ROUTE_TRAFFIC_HOME:
      return 'Itinéraire voiture'
    case ROUTE_BICYCLE_HOME:
      return 'Itinéraire à vélo'
    case ROUTE_ITINERARY_HOME:
    case ROUTE_SEO_ITINERARY:
    default:
      return 'Itinéraire'
  }
})

export const selectSeoCityLinkLabelPrefixKey = createCustomSelector(selectCurrentHistoryRoute, route => {
  switch (route) {
    case ROUTE_TRAFFIC_HOME:
    case ROUTE_BICYCLE_HOME:
    case ROUTE_ZFE_HOME:
    case ROUTE_RESTRICTION_HOME:
    case ROUTE_SEO_COUNTRY:
    case ROUTE_SEO_DEPARTMENT:
      return 'footer.cityLink.label.map'
    case ROUTE_SEO_LANDMARK:
    case ROUTE_SEO_NAMED_PLACE:
      return 'footer.cityLink.label.default.with-postcode'
    default:
      return 'footer.cityLink.label.default'
  }
})

export const selectSeoInfoTrafficOptions = createCustomSelector(
  selectCurrentHistoryRoute,
  selectFirstAddress,
  selectCurrentGeoentity,
  (route, firstAddress, geoentity) => {
    switch (route) {
      case ROUTE_ADDRESS_HOME:
        return { max: 10, hpLinkLabel: 'Info trafic en temps réel' }

      case ROUTE_SEO_LANDMARK:
      case ROUTE_SEO_NAMED_PLACE:
        return {
          hpLinkLabel: 'Info trafic en direct',
          linksLabel: 'Trafic',
          zip: projectDistrictZipcodeToWholeCityZipcode(firstAddress?.postcode)
        }

      case ROUTE_SEO_ADDRESS:
      case ROUTE_SEO_CITY_ACTIVITY:
      case ROUTE_SEO_DIRECTORY_CITY_ACTIVITY:
      case ROUTE_SEO_DIRECTORY_CITY_POIS:
      case ROUTE_SEO_DIRECTORY_CITY_OVM_POIS:
      case ROUTE_SEO_DIRECTORY_CITY_OVM_POIS_ACTIVITY:
        return { zip: projectDistrictZipcodeToWholeCityZipcode(firstAddress?.postcode) }

      case ROUTE_SEO_GEOENTITY:
        return { zip: projectDistrictZipcodeToWholeCityZipcode(geoentity?.postcode) }

      case ROUTE_TRAFFIC_HOME:
        return { min: 20, max: 200 }

      case ROUTE_TRAFFIC_CITY:
        return { max: 20 }

      case ROUTE_HOME:
      case ROUTE_BICYCLE_CITY:
      case ROUTE_ZFE_CITY:
      default:
        return { max: 10 }
    }
  }
)

export const selectSeoBicycleOptions = createCustomSelector(
  selectCurrentHistoryRoute,
  selectFirstAddress,
  selectCurrentGeoentity,
  (route, firstAddress, geoentity) => {
    switch (route) {
      case ROUTE_SEO_DIRECTORY_CITY_ACTIVITY:
      case ROUTE_SEO_DIRECTORY_CITY_OVM_POIS:
      case ROUTE_SEO_DIRECTORY_CITY_OVM_POIS_ACTIVITY:
      case ROUTE_SEO_ADDRESS:
        return {
          linksLabel: 'Carte Pistes cyclables',
          zip: projectDistrictZipcodeToWholeCityZipcode(firstAddress?.postcode)
        }
      case ROUTE_SEO_LANDMARK:
      case ROUTE_SEO_NAMED_PLACE:
        return {
          linksLabel: 'Carte Pistes cyclables',
          hpLinkLabel: 'Pistes cyclables autour de moi',
          prefix: 'Carte pistes cyclables',
          zip: projectDistrictZipcodeToWholeCityZipcode(firstAddress?.postcode)
        }

      case ROUTE_SEO_CITY_ACTIVITY:
      case ROUTE_SEO_DIRECTORY_CITY_POIS:
        return {
          hpLinkLabel: 'Pistes Cyclables',
          zip: projectDistrictZipcodeToWholeCityZipcode(firstAddress?.postcode)
        }

      case ROUTE_SEO_GEOENTITY:
        return {
          hpLinkLabel: 'Pistes Cyclables',
          zip: projectDistrictZipcodeToWholeCityZipcode(geoentity?.postcode)
        }

      case ROUTE_BICYCLE_DEPARTMENT:
      case ROUTE_BICYCLE_REGION:
        return {
          hpLinkLabel: 'Pistes Cyclables'
        }

      case ROUTE_BICYCLE_HOME:
        return { min: 20, max: 200 }

      case ROUTE_BICYCLE_CITY:
        return { max: 20 }

      case ROUTE_HOME:
      case ROUTE_ADDRESS_HOME:
      case ROUTE_TRAFFIC_CITY:
      case ROUTE_ZFE_CITY:
      default:
        return { max: 10 }
    }
  }
)

export const selectSeoZfeOptions = createCustomSelector(
  selectCurrentHistoryRoute,
  selectFirstAddress,
  selectCurrentGeoentity,
  (route, firstAddress, geoentity) => {
    switch (route) {
      case ROUTE_HOME:
        return {
          hpLinkLabel: "Zone des restrictions Crit'Air",
          max: 10,
          title: 'Zones à Faibles émissions (ZFE) en France'
        }
      case ROUTE_ADDRESS_HOME:
        return {
          hpLinkLabel: "Restrictions Crit'Air",
          linksLabel: "Crit'Air",
          max: 10
        }
      case ROUTE_SEO_GEOENTITY:
        return {
          hpLinkLabel: "Zones Crit'Air",
          zip: projectDistrictZipcodeToWholeCityZipcode(geoentity?.postcode)
        }
      case ROUTE_SEO_LANDMARK:
      case ROUTE_SEO_NAMED_PLACE:
        return {
          hpLinkLabel: 'Plan des ZFE',
          zip: projectDistrictZipcodeToWholeCityZipcode(firstAddress?.postcode),
          linksLabel: "Crit'Air"
        }
      case ROUTE_SEO_ADDRESS:
      case ROUTE_SEO_DIRECTORY_CITY_ACTIVITY:
      case ROUTE_SEO_DIRECTORY_CITY_POIS:
      case ROUTE_SEO_DIRECTORY_CITY_OVM_POIS:
      case ROUTE_SEO_DIRECTORY_CITY_OVM_POIS_ACTIVITY:
        return {
          hpLinkLabel: "Zones Crit'Air",
          zip: projectDistrictZipcodeToWholeCityZipcode(firstAddress?.postcode),
          linksLabel: "Crit'Air"
        }
      case ROUTE_SEO_CITY_ACTIVITY:
        return {
          hpLinkLabel: 'Carte des ZFE',
          zip: projectDistrictZipcodeToWholeCityZipcode(firstAddress?.postcode),
          linksLabel: "Restrictions Crit'Air"
        }
      case ROUTE_ZFE_HOME:
        return { hpLinkLabel: 'Carte des ZFE en France', min: 20, max: 200 }
      case ROUTE_TRAFFIC_CITY:
      case ROUTE_RESTRICTION_CITY:
        return { hpLinkLabel: 'Plan des ZFE', max: 10 }
      case ROUTE_BICYCLE_CITY:
        return { hpLinkLabel: 'Zone des restrictions Crit’Air', max: 10 }
      case ROUTE_ZFE_CITY:
        return {
          hpLinkLabel: 'Zone des restrictions Crit’Air',
          max: 20,
          title: 'Zones à Faibles émissions (ZFE) en France'
        }
      default:
        return { max: 10 }
    }
  }
)

export const selectSeoRestrictionOptions = createCustomSelector(
  selectCurrentHistoryRoute,
  selectFirstAddress,
  (route, firstAddress) => {
    switch (route) {
      case ROUTE_SEO_LANDMARK:
      case ROUTE_SEO_NAMED_PLACE:
        return {
          hpLinkLabel: 'Carte des restrictions de circulation',
          linksLabel: 'Restrictions circulation',
          zip: projectDistrictZipcodeToWholeCityZipcode(firstAddress?.postcode)
        }

      case ROUTE_RESTRICTION_HOME:
        return {
          hpLinkLabel: 'Carte des restrictions de circulation en France',
          min: 20,
          max: 200,
          linksLabel: 'Restrictions de circulation'
        }
      default:
        return {
          hpLinkLabel: 'Restrictions de circulation'
        }
    }
  }
)

export const selectSeoHpLayersTitle = createCustomSelector(selectCurrentHistoryRoute, route => {
  switch (route) {
    case ROUTE_DEPARTMENT_HOME:
    case ROUTE_REGION_HOME:
    case ROUTE_SEO_DIRECTORY_CITY:
    case ROUTE_SEO_DIRECTORY_ITINERARY:
    case ROUTE_SEO_DIRECTORY_ITINERARY_BY_MODE:
    case ROUTE_SEO_SEARCH_BY_APP:
    case ROUTE_TOOLS_COMPUTE_RADIUS:
    case ROUTE_SEO_CITY_APP:
    case ROUTE_SEO_DIRECTORY_NAMED_PLACE:
    case ROUTE_SEO_DIRECTORY_SKI_RESORT:
      return 'Options de Carte'
    case ROUTE_TRAFFIC_DEPARTMENT:
    case ROUTE_TRAFFIC_REGION:
    case ROUTE_RESTRICTION_DEPARTMENT:
    case ROUTE_RESTRICTION_REGION:
      return 'Autres affichages de cartes'
    default:
      return 'Affichage des cartes'
  }
})

export const selectSeoHpLayersTraffic = createCustomSelector(selectCurrentHistoryRoute, route => {
  switch (route) {
    case ROUTE_TRAFFIC_HOME:
    case ROUTE_TRAFFIC_DEPARTMENT:
    case ROUTE_TRAFFIC_REGION:
      return { visible: false }
    case ROUTE_BICYCLE_HOME:
    case ROUTE_ZFE_HOME:
    case ROUTE_RESTRICTION_HOME:
    case ROUTE_SEO_SEARCH_BY_RUBRIC:
      return { visible: true, min: 0, max: 0, hpLinkLabel: 'Info trafic en temps réel' }
    case ROUTE_DEPARTMENT_HOME:
    case ROUTE_REGION_HOME:
    case ROUTE_BICYCLE_DEPARTMENT:
    case ROUTE_BICYCLE_REGION:
    case ROUTE_ZFE_DEPARTMENT:
    case ROUTE_ZFE_REGION:
      return { visible: true, hpLinkLabel: "Carte de l'Info-trafic" }
    default:
      return { visible: true, min: 0, max: 0 }
  }
})

export const selectSeoHpLayersBicycle = createCustomSelector(selectCurrentHistoryRoute, route => {
  switch (route) {
    case ROUTE_BICYCLE_HOME:
    case ROUTE_BICYCLE_DEPARTMENT:
    case ROUTE_BICYCLE_REGION:
      return { visible: false }
    case ROUTE_TRAFFIC_HOME:
    case ROUTE_RESTRICTION_HOME:
    case ROUTE_ZFE_HOME:
      return { visible: true }
    case ROUTE_DEPARTMENT_HOME:
    case ROUTE_REGION_HOME:
      return { visible: true, hpLinkLabel: 'Plan des Pistes Cyclables' }
    case ROUTE_SEO_SEARCH_BY_RUBRIC:
    case ROUTE_TRAFFIC_DEPARTMENT:
    case ROUTE_TRAFFIC_REGION:
    case ROUTE_ZFE_DEPARTMENT:
    case ROUTE_ZFE_REGION:
    case ROUTE_RESTRICTION_DEPARTMENT:
    case ROUTE_RESTRICTION_REGION:
      return { visible: true, hpLinkLabel: 'Carte des pistes cyclables' }
    default:
      return { visible: true, hpLinkLabel: 'Pistes Cyclables' }
  }
})

export const selectSeoHpLayersZfe = createCustomSelector(selectCurrentHistoryRoute, route => {
  switch (route) {
    case ROUTE_ITINERARY_HOME:
    case ROUTE_ITINERARY_HP_BY_MODE:
    case ROUTE_ITINERARY_TO:
    case ROUTE_ITINERARY_TO_BY_MODE:
    case ROUTE_ITINERARY_COMPUTING:
    case ROUTE_ITINERARY_COMPUTING_BY_MODE:
    case ROUTE_ITINERARY_RESULTS_BY_PROVIDER:
    case ROUTE_ITINERARY_RESULTS_BY_ROUTE:
    case ROUTE_ITINERARY_EXPENSE_REPORT:
    case ROUTE_ITINERARY_ROADBOOK:
    case ROUTE_SEO_ITINERARY:
    case ROUTE_SEO_ITINERARY_MODE:
    case ROUTE_SEO_SEARCH_BY_RUBRIC:
      return { visible: true, hpLinkLabel: "Restrictions Crit'Air" }
    case ROUTE_SEO_DIRECTORY_ITINERARY_BY_MODE:
    case ROUTE_SEO_DIRECTORY_ITINERARY:
      return { visible: true, hpLinkLabel: 'Carte ZFE' }
    case ROUTE_BICYCLE_HOME:
    case ROUTE_RESTRICTION_HOME:
      return { visible: true, hpLinkLabel: 'Carte des ZFE en France' }
    case ROUTE_SEO_DIRECTORY_CITY:
    case ROUTE_TRAFFIC_HOME:
    case ROUTE_SEO_SEARCH_BY_APP:
    case ROUTE_TOOLS_COMPUTE_RADIUS:
    case ROUTE_SEO_CITY_APP:
    case ROUTE_SEO_DIRECTORY_NAMED_PLACE:
    case ROUTE_SEO_DIRECTORY_LANDMARK:
    case ROUTE_SEO_DIRECTORY_SKI_RESORT:
      return { visible: true, hpLinkLabel: 'Carte des ZFE' }
    case ROUTE_REGION_HOME:
    case ROUTE_DEPARTMENT_HOME:
      return { visible: true, hpLinkLabel: 'Plan des ZFE en France' }
    case ROUTE_TRAFFIC_DEPARTMENT:
    case ROUTE_TRAFFIC_REGION:
    case ROUTE_BICYCLE_DEPARTMENT:
    case ROUTE_BICYCLE_REGION:
    case ROUTE_RESTRICTION_DEPARTMENT:
    case ROUTE_RESTRICTION_REGION:
      return { visible: true, hpLinkLabel: 'Plan des ZFE' }
    default:
      return { visible: false }
  }
})

export const selectSeoHpLayersRestriction = createCustomSelector(selectCurrentHistoryRoute, route => {
  switch (route) {
    case ROUTE_TRAFFIC_HOME:
    case ROUTE_SEO_SEARCH_BY_RUBRIC:
    case ROUTE_SEO_DIRECTORY_ITINERARY_BY_MODE:
    case ROUTE_SEO_DIRECTORY_ITINERARY:
    case ROUTE_SEO_DIRECTORY_CITY:
    case ROUTE_TOOLS_COMPUTE_RADIUS:
    case ROUTE_SEO_DIRECTORY_LANDMARK:
    case ROUTE_SEO_DIRECTORY_NAMED_PLACE:
    case ROUTE_SEO_DIRECTORY_SKI_RESORT:
      return { visible: true, hpLinkLabel: 'Restrictions de circulation en temps réel' }
    case ROUTE_BICYCLE_HOME:
    case ROUTE_ITINERARY_HP_BY_MODE:
    case ROUTE_ITINERARY_HOME:
    case ROUTE_SEO_ITINERARY_MODE:
    case ROUTE_SEO_ITINERARY:
    case ROUTE_SEO_CITY_APP:
      return { visible: true, hpLinkLabel: 'Restrictions de circulation' }
    case ROUTE_ZFE_HOME:
    case ROUTE_ZFE_REGION:
    case ROUTE_ZFE_DEPARTMENT:
    case ROUTE_TRAFFIC_REGION:
    case ROUTE_TRAFFIC_DEPARTMENT:
    case ROUTE_BICYCLE_REGION:
    case ROUTE_BICYCLE_DEPARTMENT:
    case ROUTE_DEPARTMENT_HOME:
    case ROUTE_REGION_HOME:
    case ROUTE_SEO_SEARCH_BY_APP:
      return { visible: true, hpLinkLabel: 'Carte des restrictions de circulation' }
    default:
      return { visible: false }
  }
})

export const selectSeoPoiDirectoryLabelPrefix = createCustomSelector(selectCurrentHistoryRoute, route => {
  switch (route) {
    case ROUTE_SEO_DIRECTORY_CITY_ACTIVITY:
      return 'Tous les commerces et services de'
    default:
      return 'Commercants de'
  }
})

export const selectSeoPoiOvmDirectoryLabelPrefix = createCustomSelector(selectCurrentHistoryRoute, route => {
  switch (route) {
    case ROUTE_SEO_DIRECTORY_CITY_POIS:
    case ROUTE_SEO_DIRECTORY_CITY_ACTIVITY:
      return 'Tous les Lieux et commerçants populaires à'
    default:
      return 'Plus de lieux populaires à'
  }
})

export const selectSeoActivitiesTitle = createCustomSelector(selectCurrentHistoryRoute, route => {
  switch (route) {
    case ROUTE_SEO_SEARCH_BY_APP:
    case ROUTE_SEO_SEARCH_BY_RUBRIC:
      return 'Les villes les plus recherchées pour la catégorie Hôtel'
    default:
      return 'Activités à découvrir en France'
  }
})

export const selectSeoOtherDirectoryTitle = createCustomSelector(selectCurrentHistoryRoute, route => {
  switch (route) {
    case ROUTE_SEO_DIRECTORY_CITY:
      return 'Découvrez également nos destinations touristiques'
    default:
      return 'Découvrez nos autres destinations touristiques'
  }
})
